/**
 * Escapa caracteres HTML especiales para prevenir XSS al interpolar strings
 * en innerHTML / template literals. Convierte texto plano en entidades HTML.
 *
 * Sirve tanto para contenido entre tags como para atributos entrecomillados.
 * NO usar para atributos sin comillas, URLs, JavaScript, ni CSS — esos requieren
 * escapes diferentes.
 *
 * @param {*} value - cualquier valor; null/undefined retornan ''
 * @returns {string} string escapado
 */
const HTML_ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
};

export function escapeHTML(value) {
    if (value == null) return '';
    return String(value).replace(/[&<>"']/g, (c) => HTML_ENTITIES[c]);
}
